import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

import { AnalyticsConsentService } from '../../services/analytics-consent.service';

@Component({
    selector: 'app-cookie-banner',
    standalone: true,
    imports: [CommonModule],
    // Refusal is a "Continuer sans accepter" link on its own line under the text rather than a
    // second button (wording of figure 5 in the CNIL 2020 recommendation, upheld by the Conseil
    // d'Etat on 19/06/2026, n° 501417). It must stay clearly readable (same colour and size as
    // the text, underlined), outside the paragraph, and keep that exact wording.
    // Kept identical to FRONT/js/consent-banner.js.
    template: `
    <div class="cookie-banner" *ngIf="visible$ | async">
      <div class="cookie-banner-text">
        <p><strong>Aidez-nous à améliorer Noteefy.</strong> Avec votre accord, nous mesurons la fréquentation du site et l'efficacité de nos publicités. Vous pouvez changer d'avis à tout moment via « Gérer les cookies ». <a href="/privacy-policy.html#cookies" target="_blank" rel="noopener">En savoir plus</a></p>
        <button type="button" class="refuse" (click)="refuse()">Continuer sans accepter &rarr;</button>
      </div>
      <button type="button" class="accept" (click)="accept()">Accepter</button>
    </div>
  `,
    styles: [`
    .cookie-banner {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000000;
      background: #1c2530;
      color: #f3f5f7;
      padding: 18px 24px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      box-shadow: 0 -2px 12px rgba(0, 0, 0, .2);
    }
    .cookie-banner-text {
      flex: 1 1 380px;
    }
    .cookie-banner p {
      margin: 0 0 6px;
      font-size: 14px;
      line-height: 1.5;
      color: #f3f5f7;
    }
    .cookie-banner p a {
      color: #8ab4ff;
      text-decoration: underline;
    }
    .cookie-banner .refuse {
      cursor: pointer;
      border: 0;
      padding: 4px 0;
      background: transparent;
      color: #f3f5f7;
      font-size: 14px;
      text-decoration: underline;
    }
    .cookie-banner .accept {
      cursor: pointer;
      border: 0;
      border-radius: 8px;
      padding: 12px 32px;
      font-size: 15px;
      font-weight: 700;
      background: #2563eb;
      color: #fff;
      box-shadow: 0 2px 8px rgba(37, 99, 235, .45);
    }
    .cookie-banner .accept:hover {
      background: #1d4ed8;
    }
  `],
})
export class CookieBannerComponent {
    visible$: Observable<boolean> = this.consent.showBanner$;

    constructor(private consent: AnalyticsConsentService) {}

    accept(): void {
        this.consent.grant();
    }

    refuse(): void {
        this.consent.deny();
    }
}
